import type SecurityService from "services/securityService";

export function allowToDownload(securityService: SecurityService): boolean {
  return securityService.allowTo("finance.reports", "read");
}
export function allowToDownloadFinance(securityService: SecurityService): boolean {
  return securityService.allowTo("finance", "read");
}
